// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2-oC09NVp2","link":"_1_08_j4zL7","version":"_3Y-eAx64y2","claim":"_3TfATghkGx"};
    if(module.hot) {
      // 1597843244800
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  